/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "GetPaymentCancellationEligibilityRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetPaymentCancellationEligibilityResponse": {
                "fields": {
                  "cancelable": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "blockers": {
                    "type": ".squareup.corporate_card.service.GetPaymentCancellationEligibilityResponse.PaymentCancellationBlocker",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "PaymentCancellationBlocker": {
                    "values": {
                      "PCB_DO_NOT_USE": 0,
                      "ACCOUNT_FROZEN": 1,
                      "ACCOUNT_DEACTIVATED": 2,
                      "RATE_LIMIT_EXCEEDED": 3,
                      "ACCOUNT_DELINQUENT": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.GetPaymentCancellationEligibilityRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.GetPaymentCancellationEligibilityResponse && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.GetPaymentCancellationEligibilityResponse?.nested?.PaymentCancellationBlocker) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetPaymentCancellationEligibilityRequest @ squareup/corporate_card/service/get_payment_cancellation_eligibility.proto at 8:1
 */
export const GetPaymentCancellationEligibilityRequest = $root.lookupType('squareup.corporate_card.service.GetPaymentCancellationEligibilityRequest');
fixType(GetPaymentCancellationEligibilityRequest, {
  creditLineId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetPaymentCancellationEligibilityRequest);
/**
 * SOURCE GetPaymentCancellationEligibilityResponse @ squareup/corporate_card/service/get_payment_cancellation_eligibility.proto at 19:1
 */
export const GetPaymentCancellationEligibilityResponse = $root.lookupType('squareup.corporate_card.service.GetPaymentCancellationEligibilityResponse');
fixType(GetPaymentCancellationEligibilityResponse);
Builder.createAndAttachToType(GetPaymentCancellationEligibilityResponse);
/**
 * SOURCE PaymentCancellationBlocker @ squareup/corporate_card/service/get_payment_cancellation_eligibility.proto at 20:3
 */
GetPaymentCancellationEligibilityResponse.PaymentCancellationBlocker = $root.lookupEnum('squareup.corporate_card.service.GetPaymentCancellationEligibilityResponse.PaymentCancellationBlocker').values;